import React from 'react';
import HeaderTitle from '../../../../components/typography/header-title';
import RedisTbasTable from '../../../../components/tbas/redis';
const RedisTbas = () => {
    return (
        <>
            <HeaderTitle
                title={'Time Based Auto Scaling of Redis Databases'}
                subtitle={'Minimize Cost of Redis databases by scaling it on time based monitoring'}
            />
            <RedisTbasTable/>
        </>
    );
};

export default RedisTbas;
